function formatEuro(amount) {
  const rounded = Math.round(amount * 100) / 100;
  return rounded.toFixed(2).replace('.', ',') + ' €';
}

function syncPrice(priceEl, qtyInput) {
  const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
  const unit = parseFloat(priceEl.dataset.unitPrice || '0') / 100;
  const compareUnit = parseFloat(priceEl.dataset.unitCompareAtPrice || '0') / 100;

  priceEl.querySelectorAll('.price').forEach((el) => {
    el.textContent = formatEuro(unit * qty);
  });

  if (compareUnit > 0) {
    priceEl.querySelectorAll('.compare-at-price').forEach((el) => {
      el.textContent = formatEuro(compareUnit * qty);
    });
  }
}

function initQuantityPriceSync() {
  const qtyInput = document.querySelector(
    'quantity-selector-component input[ref="quantityInput"]:not([data-cart-line])'
  );
  if (!qtyInput) return;

  const section = qtyInput.closest('.shopify-section');
  const priceEl = section ? section.querySelector('product-price[data-unit-price]') : null;
  if (!priceEl) return;

  const update = () => syncPrice(priceEl, qtyInput);
  const deferredUpdate = () => requestAnimationFrame(update);

  qtyInput.addEventListener('input', update);
  qtyInput.addEventListener('blur', update);

  const quantitySelector = qtyInput.closest('quantity-selector-component');
  quantitySelector
    ?.querySelectorAll('button[name="minus"], button[name="plus"]')
    .forEach((btn) => btn.addEventListener('click', deferredUpdate));

  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityPriceSync);
} else {
  initQuantityPriceSync();
}
